var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"cxm-TableCell",class:_vm.classes},[(_vm.blocked === true && _vm.lockable === true)?_c('span',{staticClass:"cxm-TableCell-Blur"},[_vm._v("\n    locked\n  ")]):(_vm.isAction)?_c('div',{staticClass:"cxm-TableCell-ActionCell"},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }